"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gatewayConfig = void 0;
var gatewayConfig = function () { return ({
    channels: {
        portfolio: 'portfolio',
        symbolPriceUpdate: 'symbolPriceUpdate',
    },
    events: {
        common: {
            pub: {
                error: 'error',
            },
        },
        portfolio: {
            pub: {
                recalculationProgress: 'recalculationProgress',
            },
            sub: {
                requestRecalculationProgress: 'requestRecalculationProgress',
            },
        },
        symbolPriceUpdate: {
            pub: {
                data: 'symbolPriceUpdateData',
            },
            sub: {
                subscribe: 'subscribeSymbolPriceUpdate',
                unsubscribe: 'unsubscribeSymbolPriceUpdate',
            },
        },
    },
}); };
exports.gatewayConfig = gatewayConfig;
//# sourceMappingURL=gateway-config.js.map